module.exports = __webpack_public_path__ + "static/38-04b1e9f7010c2d371954cf08f6588487.jpg";